import { t } from 'utils/getTranslations';

export interface FinalizedHoursDto {
    clientHours: number;
    proBonoHours: number;
    offerHours: number;
    internalHours: number;
    bdEffortHours: number;
    totalHours: number;
}

export interface PieChartItem {
    id: string;
    value: number;
    label: string;
    color: string;
    tooltip?: string;
}

export type DashboardHoursTab = 'finalized-hours' | 'progress-tracking';

export interface DashboardForm {
    selectedTimeRange: { label: string; value: TimeRangeOption } | null;
    dateFrom: string;
    dateTo: string;
    // Absent from data persisted before the hours card had tabs.
    hoursTab?: DashboardHoursTab;
}

export type TimeRangeOption =
    | 'today'
    | 'yesterday'
    | 'current-week'
    | 'last-week'
    | 'current-month'
    | 'last-month'
    | 'current-year'
    | 'last-year'
    | 'custom';

export const timeRangeOptions: { value: TimeRangeOption; label: string }[] = [
    { value: 'today', label: t('time.today') },
    { value: 'yesterday', label: t('time.yesterday') },
    { value: 'current-week', label: t('time.current-week') },
    { value: 'last-week', label: t('time.last-week') },
    { value: 'current-month', label: t('time.current-month') },
    { value: 'last-month', label: t('time.last-month') },
    { value: 'current-year', label: t('time.current-year') },
    { value: 'last-year', label: t('time.last-year') },
    { value: 'custom', label: t('time.custom-date-range') },
];
